import { getCookie, setCookie } from "./cookies";
import { getQueryParam } from "./query_params";

const sessionTimestampCookie = "msm-session-timestamp";

function isClientSessionStart(): boolean {
  const sessionTimestamp = getCookie(sessionTimestampCookie);
  const qsMusementId = getQueryParam("musementId");
  if (sessionTimestamp) {
    return false;
  } else if (qsMusementId) {
    const timestamp = Date.now();
    setCookie({
      name: sessionTimestampCookie,
      value: timestamp,
    });
    return false;
  } else {
    const timestamp = Date.now();
    setCookie({
      name: sessionTimestampCookie,
      value: timestamp,
    });
    return true;
  }
}

export { isClientSessionStart };
